import CreatorEditorScreen from '@/features/unified-learning/creator/screens/CreatorEditorScreen';

export default CreatorEditorScreen;
